// extracted by mini-css-extract-plugin
module.exports = {"spinner":"styles_spinner__eSfzO","variant_light":"styles_variant_light__bCdV4","variant_dark":"styles_variant_dark__WRWWo","spin":"styles_spin__Pkdu3"};